<template>
  <div class="addclient">
    <div class="card-block">
      <div class="row justify-content-center" v-if="phoneNumbers.length > 0">
        <div class="col-md-12">
        </div>
        <div class="col-md-12">
          <table class="table" data-testid="registration-phone-list">
            <thead>
            <tr>
              <th>Telefonní číslo</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="phoneNum in phoneNumbers" class="card-text">
              <tr>
                <td class="align-middle">
                  {{ phoneNum.number }}
                </td>
                <td>
                  {{ phoneNum.default === true ? 'výchozí' : '' }}
                </td>
                <td>
                  {{ phoneNum.note }}
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-center">
        <form v-if="!waitForData" @submit.prevent="submitForm" data-testid="registration-phone-form">
          <div class="form-group col-md-12">
            <div class="input-group">
              <span class="input-group-addon">{{ selectedPhoneNumberPrefix }}</span>
              <input v-model="selectedPhoneNumber" type="number" placeholder="telefonní číslo" class="form-control" id="phoneNumber" data-testid="registration-phone-number">
              <span class="input-group-addon">
                          Výchozí:&nbsp;
                        <input v-model="phoneNumber.default" type="checkbox" aria-label="Checkbox for following text input" data-testid="registration-phone-default">
                      </span>
              <input v-model="phoneNumber.note" type="text" class="form-control" id="phoneNumberf" data-testid="registration-phone-note" placeholder="poznámka">
              <button v-if="phoneNumberPending === false" type="submit" class="btn btn-primary" data-testid="registration-phone-add">Přidat telefon</button>
              <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            </div>
            <small id="numberError" class="form-text text-danger" data-testid="registration-phone-error" v-if="phoneNumberError.number">{{ phoneNumberError.number.message }}</small>

            <!--<input type="text" class="form-control"  >-->
          </div>
        </form>
      </div>
      <div class="row justify-content-center">
        <div class="form-group col-md-12 text-center">

          <button v-if="phoneNumberPending || phoneNumbersPending" class="btn btn-primary disabled" disabled="disabled"><i class="fa fa-spinner fa-pulse fa-fw"></i> Čekám</button>
          <button v-else="" class="btn btn-primary" @click="nextStep" data-testid="registration-phone-next">Další krok <i class="fa fa-arrow-right"></i></button>
        </div>
      </div>

      <div  v-if="waitForData" class="row justify-content-around">
        <div class="">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        // phone number
        phoneNumberError: {},
        phoneNumberPending: false,
        phoneNumber: {
          number: '',
          default: true,
          note: ''
        },
        selectedPhoneNumberPrefix: '+420',
        selectedPhoneNumber: '',
        // phone numbers
        phoneNumbersPending: false,
        phoneNumbers: [],
        phoneNumbersError: {},
        // client
        clientError: '',
        client: '',
        // others
        setting: require('../../../variables.js'),
        clientid: '',
        waitForResponse: false,
        waitForData: false,
        decodePinPending: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: [],
        pinDecodeError: []
      }
    },
    methods: {
      submitForm () {
        this.postPhoneNumber()
      },
      nextStep () {
        this.$emit('completed-step', 4)
      },
      getPhoneNumbers () {
        this.phoneNumbersPending = true
        this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number').then(response => {
          this.phoneNumbers = response.data
          this.phoneNumbersPending = false
        }).catch(error => {
          this.phoneNumbersError = error.response.data.errors
          this.phoneNumbersPending = false
        })
      },
      customLabel ({ code, name }) {
        return `${code} – ${name}`
      },
      postPhoneNumber () {
        this.phoneNumberPending = true
        this.phoneNumber.number = this.selectedPhoneNumberPrefix + this.selectedPhoneNumber
        this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number', this.phoneNumber, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.phoneNumberPending = false
          this.getPhoneNumbers()
        }).catch(error => {
          this.phoneNumberError = error.response.data.errors
          this.phoneNumberPending = false
        })
      },
      getClient () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid).then(response => {
          this.client = response.data
          this.waitForData = false
          if (this.client.health_insurance !== null) {
            this.$emit('completed-step', 2)
          }
        }).catch(error => {
          this.clientError = error.response.data.errors
          this.waitForData = false
        })
      }
    },
    beforeMount () {
      this.getPhoneNumbers()
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .icon-male {
    color: dodgerblue;
    font-weight: bold;
  }

  .icon-female {
    color: deeppink;
    font-weight: bold;
  }

  .icon-genderless {
    color: #ccc;
    font-weight: bold;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    vertical-align: middle;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/Registration/components/RegistrationClientPhone.vue?9036fb56